import type { ReactNode } from "react";
import { useWidgetConfig } from "../../customization/hooks/use-widget-config";
import { ExternalWalletProvider } from "./external-wallet-provider";
import { InternalWalletProvider } from "./internal-wallet-provider";

interface WalletProviderProps {
  children: ReactNode;
}

export function WalletProvider({ children }: WalletProviderProps) {
  const { features } = useWidgetConfig();
  const isWidgetOnlyBuild = import.meta.env.VITE_WIDGET_ONLY === "true";

  // If not a widget-only build, always use the internal wallet provider
  if (!isWidgetOnlyBuild) {
    return <InternalWalletProvider>{children}</InternalWalletProvider>;
  }

  if (features.walletMode === "external") {
    return <ExternalWalletProvider>{children}</ExternalWalletProvider>;
  }

  return <InternalWalletProvider>{children}</InternalWalletProvider>;
}
